const recoveryStorageKey = 'sugarm:vite-preload-recovery-url'

/**
 * Vite emits this event when a browser still has an old entry bundle after a
 * deploy, but that entry tries to lazy-load a chunk that no longer exists.
 * Reload once to fetch the current index.html; never loop forever if the new
 * page has a genuine loading failure.
 */
export function installVitePreloadRecovery(): void {
  window.addEventListener('vite:preloadError', (event) => {
    const currentURL = window.location.href

    try {
      if (window.sessionStorage.getItem(recoveryStorageKey) === currentURL) {
        return
      }

      window.sessionStorage.setItem(recoveryStorageKey, currentURL)
      event.preventDefault()
      window.location.reload()
    } catch {
      // Storage can be unavailable in restrictive browser contexts. Keeping
      // the original Vite error is safer than risking an endless reload loop.
    }
  })
}

export function clearVitePreloadRecovery(): void {
  try {
    window.sessionStorage.removeItem(recoveryStorageKey)
  } catch {
    // Nothing to clear when storage is unavailable.
  }
}
